import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import SliderManager from "./SliderManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import GuideText from "../../../../../src/entities/GuideText";
import Cat from "../entities/Cat";
import CatModeSwitcherCon from "../entities/CatModeSwitcherCon";
import SecondAngleSwitcherCon from "../entities/SecondAngleSwitcherCon";
import isCircumPointBetween from "../../../../../src/utils/isCircumPointBetween";
import setCircleColors from "../helpers/setCircleColors";
import isPortail from "../../../../../src/utils/isPortial";
import { ARC_COLOR_ARR, CENTER_OF_CIRCLE, CIRCLE_RADIUS, INFO_SLIDER_COORD, INITIAL_RADIANS } from "../types/Config";
import SegmentChord from "../entities/SegmentChord";


export default class ComponentManager {
  static instance: ComponentManager;
  Game = Game.getInstance();
  circleRadius = CIRCLE_RADIUS;
  cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);

  SliderManager = new SliderManager();
  PointManager = new PointManager(this.cCoord);
  PointTagManager = new PointTagManager(this.cCoord);
  LineManager = new LineManager();
  InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
  AngleManager = new AngleManager();
  circle = new Circle(this.cCoord, INITIAL_RADIANS, ARC_COLOR_ARR);
  CircleAnimationManager: CircleAnimationManager;
  cat = new Cat(this.cCoord);
  catModeSwitcherCon = new CatModeSwitcherCon();
  secondAngleSwitcherCon = new SecondAngleSwitcherCon();
  SegmentChord = new SegmentChord(this.cCoord);
  isShownSecondAngles = false;

  constructor() {
    if (!ComponentManager.instance) {
      ComponentManager.instance = this;
    }
    new GuideText();
    this.CircleAnimationManager = new CircleAnimationManager(
      this.PointManager,
      this.PointTagManager,
      this.AngleManager,
      this.LineManager,
      this.circle,
      this.cCoord
    );
    
    rootEventBus.emit(EnumRootEventBus.getCircleCoord, this.cCoord);

    eventBus.on(EnumEventBus.showSecondAngles, v => this.setShowSecondAngles(v));
    rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.drawElements());
    this.drawElements();
  }
  static getInstance = () => ComponentManager.instance;

  setShowSecondAngles(v: boolean) {
    this.isShownSecondAngles = v;
    this.drawElements();
  }

  drawElements() {
    const radians = this.PointManager.getRadians();
    const redPointsCoord = this.PointManager.getRedPointsCoord();
    const isBtwA = isCircumPointBetween(this.cCoord, redPointsCoord[0], radians[3], radians[2]);
    const isBtwB = isCircumPointBetween(this.cCoord, redPointsCoord[1], radians[3], radians[2]);
    const r = setCircleColors(this.circle, radians, [isBtwA, isBtwB], this.isShownSecondAngles);

    this.circle.draw({ radians: r, radius: this.circleRadius });
    this.PointTagManager.updateCoord(radians, this.circleRadius)
    this.LineManager.draw(redPointsCoord);
    this.AngleManager.draw(redPointsCoord, [isBtwA, isBtwB], this.isShownSecondAngles);
    this.SegmentChord.draw(CIRCLE_RADIUS, [radians[2], radians[3]], [redPointsCoord[2], redPointsCoord[3]], (isBtwA || isBtwB));
    this.cat.updateCoord(radians);
  }
}